<div class="splash-wrapper flex flex-col">
  <div
    class="splash-content flex flex-col items-center justify-center gap-3 flex-1"
  >
    <svg-icon src="assets/my-fruit-logo.svg"></svg-icon>
    <div class="text-surface-500 text-xl font-regular p-5 font-jost">
      {{ 'features.splashScreen.label' | translate }}
    </div>
  </div>

  <div
    class="buttons-container flex flex-col items-center justify-center w-full px-6"
  >
    <button
      class="px-6 py-4 bg-primary-500 rounded-lg w-full text-white text-center font-bold font-jost uppercase"
      (click)="login()"
      [disabled]="isLoggingIn()"
      [class.opacity-50]="isLoggingIn()"
      [class.cursor-not-allowed]="isLoggingIn()"
    >
      {{ isLoggingIn() ? 'Logging in...' : ('features.splashScreen.loginButton'
      | translate) }}
    </button>
    <!--<button
      class="px-6 py-4 bg-transparent w-full text-surface-900 text-center font-bold font-jost"
      (click)="demoLogin()"
      [disabled]="isLoggingIn()"
      [class.opacity-50]="isLoggingIn()"
      [class.cursor-not-allowed]="isLoggingIn()"
    >
      {{ isLoggingIn() ? 'Connecting...' : ('features.splashScreen.demoButton' |
      translate) }}
    </button>-->
    <div
      class="px-6 py-4 bg-transparent w-full text-surface-900 text-center font-bold font-jost"
    >
      {{ isLoggingIn() ? 'Connecting...' : '' }}
    </div>
  </div>
</div>
